import React from 'react';
import PropTypes from 'prop-types';
import { Input, Fields, PadContainer, SingleSelect } from 'smartsuite-ui';
import { isRecordLimitValid } from './filtersModalUtils';
import { useLabelContext } from '../hooks/labelContext';

export default function RecordLimit({
    recordLimitConfig,
    saveRecordLimit,
    showRecordLimit,
}) {
    const { dashboardLabels } = useLabelContext();

    function handleIsDescendingChange(event) {
        saveRecordLimit({
            ...recordLimitConfig,
            isDescending: !!event.valueField,
        });
    }

    function handleRecordLimitChange(event) {
        saveRecordLimit({
            ...recordLimitConfig,
            recordLimit: event.target.value,
        });
    }

    if (!showRecordLimit) {
        return null;
    }

    const isDescendingOptions = [
        { textField: dashboardLabels.top, valueField: true },
        { textField: dashboardLabels.bottom, valueField: false },
    ];

    return (
        <>
            <PadContainer
                cssClassModifiers={['pad-medium', 'no-pad-left-right']}
            >
                <Fields
                    cssClassModifiers={['no-background', 'no-pad-top-bottom']}
                >
                    <SingleSelect
                        label={dashboardLabels.recordLimit}
                        isClearable={false}
                        onChange={handleIsDescendingChange}
                        options={isDescendingOptions}
                        textField="textField"
                        valueField="valueField"
                        value={
                            isDescendingOptions.find(
                                (x) =>
                                    x.valueField ===
                                    recordLimitConfig.isDescending
                            ) ?? isDescendingOptions[0]
                        }
                    />
                    <Input
                        isValid={isRecordLimitValid(recordLimitConfig)}
                        onChange={handleRecordLimitChange}
                        placeholder={dashboardLabels.recordLimitPlaceholder}
                        type="Number"
                        value={recordLimitConfig.recordLimit}
                    />
                </Fields>
            </PadContainer>
            <hr className="divider divider--criteria" />
        </>
    );
}

RecordLimit.propTypes = {
    recordLimitConfig: PropTypes.instanceOf(Object).isRequired,
    saveRecordLimit: PropTypes.func.isRequired,
    showRecordLimit: PropTypes.bool.isRequired,
};
